import React, { useState, useEffect } from 'react';
import { LocalizedData, Records } from './types';
import PadaRecord from './PadaRecord';
import {useToastQueue} from './hooks/useToastMessage';

/* ----------  Globals ---------- */
declare global {
  interface Window {
    PadaVistaData?: LocalizedData;
  }
}

/* ----------  Main Component ---------- */
const PadaVista: React.FC = () => {
  const { showMessage, fadeOut, progress, message, addMessage, deleteQueue} = useToastQueue();

  function ordenarMenAMay(vector) {
    let aux = 0;
    let desordenado = true;
    let lon = vector.length - 1;
    while (desordenado) {
      desordenado = false;
      for (let i = 0; i < lon; i++) {
        if (vector[i] > vector[i + 1]) {
          aux = vector[i];
          vector[i] = vector[i + 1];
          vector[i + 1] = aux;
          desordenado = true;
        }
      }
      lon -= 1;
    }
    return vector;
  }

  /* 1. Datos de inicio */
  const localizedData: LocalizedData | null = window.PadaVistaData?.[0] || null;
  if (!localizedData?.data) {
    addMessage('No se encontraron datos de inicialización');
    return (
      <div className="nav-wrapper">
        {message && showMessage && (
          <div className={`flex global-success-message ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'} ${fadeOut ? 'fade-out' : ''}`}>
            <div className='flex'>
              <span>{message}</span>
              <button className='global-message-delete pointer-events-active' onClick={() => deleteQueue()}>x</button>
            </div>
            <div
              className={`global-message-progress ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'}`}
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
        <h2 className="nav-title">PADA</h2>
        <nav className="flex justify-center mb-4 flex-wrap"></nav>
        <section className="nav-content"></section>
      </div>
    );
  }

  const { ajax_url, site_url, nonces, data } = localizedData.data;

  const records: Records[] = data.records;

  if (records.length <= 0) {
    return (
      <div className="nav-wrapper">
        {message && showMessage && (
          <div className={`flex global-success-message ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'} ${fadeOut ? 'fade-out' : ''}`}>
            <div className='flex'>
              <span>{message}</span>
              <button className='global-message-delete pointer-events-active' onClick={() => deleteQueue()}>x</button>
            </div>
            <div
              className={`global-message-progress ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'}`}
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
        <h2 className="nav-title">PADA</h2>
        <nav className="flex justify-center mb-4 flex-wrap"></nav>
        <section className="nav-content">
          <div className="no-files-message">
            <p>No hay archivos disponibles.</p>
          </div>
        </section>
      </div>
    );
  }

  const years: string[] = [];
    records.map((record, index) => {
      if(record.is_active == '1'){
        years.push(record.record_year);
      }
  });

  /* 2. Estado de year */
  const [currentYear, setCurrentYear] = useState<string>('');

  /* 3. Cambio de año */
  const changeTab = (year: string) => {
    setCurrentYear(year);
    // setVisibleTabs(baseTabs); 
  };

  /* 4. Contenido dinámico */
  const renderContent = () => {
    return records
      .filter((record) => currentYear === record.record_year)
      .map((record) => (
        <PadaRecord 
          key={record.record_year}
          site_url={site_url} 
          record={record}
        />
      ));
  };
  ordenarMenAMay(years);

  useEffect(() => {
    setCurrentYear(years[0]);
  }, []);

  /* 7. Render */
  return (
    <div className="nav-wrapper">
      {message && showMessage && (
        <div className={`flex global-success-message ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'} ${fadeOut ? 'fade-out' : ''}`}>
          <div className='flex'>
            <span>{message}</span>
            <button className='global-message-delete pointer-events-active' onClick={() => deleteQueue()}>x</button>
          </div>
          <div
            className={`global-message-progress ${message.includes('❌') || message.includes('⚠️') ? 'error' : 'success'}`}
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
      <h2 className="nav-title" style={{ fontSize: '1.5rem' }}>PADA</h2>

      {/* Barra de pestañas */}
      <nav className="flex justify-center mb-4 flex-wrap nav-items">
        {years.map((tabId) => (
          <button
            key={tabId}
            className={`admin-nav-btn ${currentYear === tabId ? 'active' : ''}`}
            onClick={() => changeTab(tabId)}
          >
            {tabId}
          </button>
        ))}
      </nav>

      {/* Contenido */}
      <section className="nav-content">{renderContent()}</section>
    </div>
  );
};

export default PadaVista;
